import { FC } from 'react';

interface LineDelimiterProps {
  hideOnDesktop?: boolean;
}

export const LineDelimiter: FC<LineDelimiterProps> = ({ hideOnDesktop }) => {
  return <div className={`w-full ${hideOnDesktop ? 'sm:hidden' : ''} my-8 border-b border-input-border`} />;
};
